module.exports = __webpack_public_path__ + "img/403499324.2c081ea1.svg";